export const USER_CREATE_ESTIMATE_SUCCESS = 'BID_ESTIMATE_CREATE_ESTIMATE'